module.exports = __webpack_public_path__ + "img/image-cart.fa84bfab.png";